<p>shared-error-dialog works!</p>
